export default {
    /** 图标大小 */
    size: "1em",
    /** 颜色 */
    color: "#333",
    /** 单色模式 */
    monochrome: false,
    /** 是否将图标内容居中 */
    center: false
}
